export default [
  {
    title: 'Dashboard',
    key: 'Dashboard',
    url: '/admin/Dashboard',
    icon: 'icmn icmn-home',
  },
  {
    title: 'Promociones',
    key: 'Promo',
    url: '/admin/promocion',
    icon: 'fa fa-tags',
  },
  {
    title: 'Ordenes',
    key: 'Order',
    url: '/admin/Order',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'Productos',
    key: 'Productos',
    url: '/admin/Products',
    icon: 'icmn icmn-barcode',
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js